import React from 'react'
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Autoplay, Navigation, Pagination } from 'swiper/core';
import PublicationCard from '../publicationCard/publicationCard.component';
import { BsFillArrowRightCircleFill, BsFillArrowLeftCircleFill } from "react-icons/bs";

import "swiper/swiper.min.css";
import "swiper/components/pagination/pagination.min.css";
import 'swiper/components/navigation/navigation.min.css';


// install Swiper modules
SwiperCore.use([Navigation, Autoplay, Pagination]);

const PublicationCarousel = ({publications, featuredPublicaiton}) => {
  return (
    <>
        <Swiper
            // effect={'coverflow'}
            modules={[Pagination, Navigation]}
            slidesPerView={1}
            spaceBetween={10}
            navigation={{
                enabled: true,
            }}
            // pagination={{
            //     clickable: true
            // }}
            breakpoints={{
                640: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                },
                768: {
                    slidesPerView: 3,
                    spaceBetween: 40,
                },
                1024: {
                    slidesPerView: 4,
                    spaceBetween: 50,
                },
                1200: {
                    slidesPerView: 4,
                    spaceBetween: 50,
                },
            }}
            autoplay={{
                "delay": 2500,
                "pauseOnMouseEnter": true,
                "disableOnInteraction": false
            }}
            className="publication-swiper"
        >
            {featuredPublicaiton && featuredPublicaiton.length > 0 ? featuredPublicaiton.map((item, index) => {
                if (index < 10) {
                    return (
                        <SwiperSlide key={`key_${item._id}`}>
                            <PublicationCard item={item} hide={true} />
                        </SwiperSlide>
                    )
                } else return null
            }) : publications.map((item, index) => {
                if (index < 10) {
                    return (
                        <SwiperSlide key={`key_${item._id}`}>
                            <PublicationCard item={item} hide={true} />
                        </SwiperSlide>
                    )
                } else return null
            })}
        </Swiper>
    </>
  )
}

export default PublicationCarousel